<app-header *ngIf="user?.id"></app-header>
<app-menu *ngIf="user?.id"></app-menu>
<router-outlet></router-outlet>
<app-footer *ngIf="user?.id"></app-footer>
